<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>트레이 등록</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="cancelUpdate">트레이 리스트</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div class="table-content">
        <table>
          <tr>
            <td class="header">트레이 ID</td>
            <!-- TODO <td><input type="text" v-model="tray.trayAlias" /></td> -->
            <td>-자동생성-</td>
          </tr>
          <tr>
            <td class="header">냉장고 ID</td>
            <!-- TODO <td>{{ device.alias }}</td> -->
            <td>{{ device.id }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">트레이 이름</td>
            <td><input type="text" v-model="tray.trayName" /></td>
          </tr>
          <tr>
            <td class="header">냉장고 이름</td>
            <td>{{ device.name }}</td>
          </tr>
        </table>
      </div>
      <div class="table-btn center">
        <button class="btn btn-140 btn-blue-line" @click="excuteUpdate">
          <span v-if="!processing" class="process">등록</span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'device',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    tray: {
      trayAlias: null,
      trayName: null,
      deviceID: null,
    },
    processing: false,
  }),
  created() {
    this.tray.deviceID = this.device.id;
  },
  methods: {
    async excuteUpdate() {
      try {
        this.processing = true;
        const createUrl = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/tray`;

        const createResult = await this.$http.post(createUrl,
          this.tray,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        /*
        const device = {
          id: this.device.deviceID,
          name: this.device.deviceName,
          alais: this.device.deviceAlias,
          pID: this.device.companyID,
          pName: this.device.companyName,
          pAlais: this.device.companyAlias,
        };
        this.$emit('refreshList', device, 'device', 1);
        */
        this.processing = false;
        this.$emit('refreshList', this.device, 'device', 1);
      } catch (e) {
        console.error(e);
        this.processing = false;
      }
    },
    cancelUpdate() {
      /*
      const device = {
        id: this.device.deviceID,
        name: this.device.deviceName,
        alais: this.device.deviceAlias,
        pID: this.device.companyID,
        pName: this.device.companyName,
        pAlais: this.device.companyAlias,
      };
      this.$emit('refreshList', device, 'device');
      */
      this.$emit('refreshList', this.device, 'device');
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tray/TrayCreate.vue